<template>
  <div class="define-table-wrap">
    <c-table
      :data="tableData"
      :props="config.props"
      :header="config.tableColumn"
      class="defineTable"
    ></c-table>
  </div>
</template>

<script>
export default {
  name: 'DefineTable',
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  computed: {
    tableData () {
      let temp = JSON.parse(JSON.stringify(this.chartData))
      let count = this.config.tableData.count || 2
      return temp.splice(0, count)
    }
  }
}
</script>

<style lang="stylus">
.define-table-wrap
  padding 10px 0
  .defineTable
    .el-table--border, .el-table--group
      border 1px solid #241f3d
    .el-table--border::after, .el-table--group::after, .el-table::before
      background none
    .el-table th
      background-image linear-gradient(90deg,#005eff,#1896ff)
      color #ffffff
      text-align center
    .el-table tr
      background #1a1533
    .el-table td
      color #a5a5b4
    .el-table td, .el-table th.is-leaf
      border-bottom 1px solid #241f3d
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
      border-right 1px solid #241f3d
    .el-table td, .el-table th
      padding 8px 0
    .el-table::before
      background-color #191c21
    .el-table--enable-row-hover .el-table__body tr:hover>td
      background-color #1f1e44
    .el-table--striped .el-table__body tr.el-table__row--striped td
      background #1f1e44
    .el-table__empty-block
      background #201e44
    .el-table--scrollable-x .el-table__body-wrapper
      overflow-x hidden
    .el-table, .el-table__expanded-cell
      background none
</style>
